import React from 'react';
import { SvgIcon } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import { Button, useTranslate } from 'react-admin';
import { TextField } from '~/components';
import { ArrowForwardCircleIcon } from '~/img';
import palette from '~/theme/palette';
import { useApprovalCase } from '~/hooks/useApprovalCaseContext';
import { useEditMode } from '~/hooks/useEditModeContext';

interface Props {
  /** 'aside' is the fixed-width panel beside the record; 'inline' fills its container. */
  variant?: 'aside' | 'inline';
}

/** Says that a change to the record is awaiting approval, so it cannot be edited. */
const PendingCaseNotice = ({ variant = 'aside' }: Props) => {
  const classes = useStyles();
  const { pendingCase, isLoading, canViewCase } = useApprovalCase();
  const { editMode } = useEditMode();

  const translate = useTranslate();
  const t = (key: string): string => translate(`components.RecordTitle.${key}`);

  if (editMode === 'CHANGELOG' || isLoading || !pendingCase) {
    return null;
  }

  return (
    <div className={variant === 'inline' ? classes.inline : classes.rightContent}>
      <Paper className={classes.editLockMode}>
        <Grid className={classes.rightContainer} container justify='space-between'>
          <Grid container justify='space-between'>
            <Grid item>
              <TextField>{t('lockEditTitle')}</TextField>
              <TextField label={t('lockEditDescription')}> </TextField>
            </Grid>
            {canViewCase && (
              <Grid item>
                <Button
                  label={t('viewCase')}
                  href={`/approvals/queue/${pendingCase.id}/show`}
                  target='_blank'
                  onClick={(e: any) => e.stopPropagation()}
                >
                  <SvgIcon>
                    <ArrowForwardCircleIcon />
                  </SvgIcon>
                </Button>
              </Grid>
            )}
          </Grid>
        </Grid>
      </Paper>
    </div>
  );
};

const useStyles = makeStyles((theme) => ({
  inline: {
    marginBottom: theme.spacing(2),
  },
  rightContent: {
    flexGrow: 0,
    flexShrink: 0,
    width: '300px',
    minWidth: '300px',
    alignSelf: 'center',
    marginTop: '-8px',
    /* eslint-disable no-useless-computed-key */
    ['@media (min-width: 1280px)']: {
      width: '360px',
    },
  },
  editLockMode: {
    backgroundColor: palette.lockEdit.base,
  },
  rightContainer: {
    padding: '8px',
    flexWrap: 'nowrap',
    alignItems: 'center',
  },
}));

export default PendingCaseNotice;
